import React, { useEffect, useState, useRef } from "react";
import Footer from "../common/Footer/Footer";
import Header from "../header/Header";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";
import { Router, useLocation, useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { getRealBalance, setCrashGames } from "../signIn/cl_SignInSlice";
import BottomMenu from "../home/BottomMenu/BottomMenu";
import PushNotificationModal from "../home/landingBanners";
import icons from "../../assets/images/sprite-other-icons.svg";
import { fetchBanners } from "../banners/cl_Banners";
import { setGameDetails, setGamePopup } from "../crashGames/cl_CrashSlice";
import { setSignupSuccess } from "../signUp/cl_SignUpSlice";
import useFilterGamesByType from "../../services/helper/filterGamesByType";
import LoyaltyConfig from "../../assets/loyaltyPointsConfig.json";

const HomeLayout = ({ element }) => {
  const topRef = useRef(null);
  const navigate = useNavigate();
  const shouldIgnoreRoute = (labelName, menuLink) => {
  const ignoredRoutes = [
    'loyaltyprelogin',
    'promotions', 
    'offers'
  ];
  
  // Check labelName (case insensitive)
  if (labelName && ignoredRoutes.some(route => 
    labelName.toLowerCase().includes(route.toLowerCase())
  )) {
    return true;
  }
  
  // Check menuLink path
  if (menuLink && ignoredRoutes.some(route => 
    menuLink.toLowerCase().includes(route.toLowerCase())
  )) {
    return true;
  }
  
  return false;
};

  useEffect(() => {
    topRef.current.scrollIntoView(true);
  }, []);
  let location = useLocation();
  const dispatch = useDispatch();
  const [pathChange, setPathChange] = useState(false);
  const { crashGames } = useSelector((state) => state?.signIn);
  const token = getFromLocalStorage("gk");
  const { signupSuccess } = useSelector((state) => state?.signUp);
  const [isNewSignup, setIsNewSignup] = useState(() => {
    return sessionStorage.getItem("isNewSignup") === "true";
  });
  const { userLoyalty } = useSelector((state) => state?.signIn);
  useEffect(() => {
    if (location.pathname === "/responsibleGambling") {
      setPathChange(true);
    } else {
      setPathChange(false);
    }
    if (location.pathname === "/") {
      dispatch(setCrashGames(false));
      if (token) {
        dispatch(getRealBalance());
      }
    }
  }, [location, token]);

  // function initFreshChat() {
  //   if (typeof window.fcWidget !== "undefined") {
  //     window.fcWidget.init({
  //       token: "OMIymK3pvcEm9ly1YGI5QmIw3qhzXFfBMjEcqpqDdhY=",
  //       host: "https://uae.fw-cdn.com",
  //     });
  //   } else {
  //     console.error("Freshchat widget not loaded.");
  //   }
  // }

  // function initialize(i, t) {
  //   var e;
  //   if (i.getElementById(t)) {
  //     initFreshChat();
  //   } else {
  //     e = i.createElement("script");
  //     e.id = t;
  //     e.async = true;
  //     e.src = "//uae.fw-cdn.com/40192381/119724.js";
  //     e.setAttribute("chat", "true");
  //     e.onload = initFreshChat;
  //     i.head.appendChild(e);
  //   }
  // }

  // function initiateFreshchat() {
  //   initialize(document, "Freshchat-js-sdk");
  // }

  // const handleChatClick = () => {
  //   initiateFreshchat();
  //   if (window.fcWidget) {
  //     window.fcWidget.open();
  //   }
  // };

  function adjustMainSectionHeight() {
    requestAnimationFrame(() => {
      const depositHeader = document.querySelector(".SB-deposit-header");
      const mainHeader = document.querySelector(".SB-mainHeader");
      const mobileFooter = document.querySelector(".SB-mobile-footer");
      const mainSectionContent = document.querySelector(
        ".SB-mainSection-content"
      );

      const depositHeight = depositHeader?.offsetHeight || 0;
      const mainHeaderHeight = mainHeader?.offsetHeight || 0;
      const mobileFooterHeight = mobileFooter?.offsetHeight || 0;

      const adjustedHeight = `calc(100dvh - ${
        mainHeaderHeight + depositHeight + mobileFooterHeight + 12
      }px)`;
      if (mainSectionContent) {
        mainSectionContent.style.height = adjustedHeight;
      }
    });
  }
  const [showBonusModal, setShowBonusModal] = useState(false);
  const [bonusAmount, setBonusAmount] = useState(0);
  const { balanceDetails } = useSelector((state) => state?.signIn);
  const previousLockedBonusRef = useRef(null);

  useEffect(() => {
    if (balanceDetails?.bonus_summary?.result?.data) {
      const currentLockedBonus =
        balanceDetails.bonus_summary.result.data.lockedBonus;

      if (
        previousLockedBonusRef.current !== null &&
        previousLockedBonusRef.current > currentLockedBonus
      ) {
        const convertedAmount =
          previousLockedBonusRef.current - currentLockedBonus;
        setBonusAmount(convertedAmount);
        setShowBonusModal(true);
      }

      previousLockedBonusRef.current = currentLockedBonus;
    }
  }, [balanceDetails?.bonus_summary?.result?.data]);

  useEffect(() => {
    window.addEventListener("resize", adjustMainSectionHeight);

    const observer = new MutationObserver(() => {
      adjustMainSectionHeight();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"],
    });

    return () => {
      window.removeEventListener("resize", adjustMainSectionHeight);
      observer.disconnect();
    };
  }, []);

  // useEffect(() => {
  //   initiateFreshchat();
  // }, []);

  const style = document.createElement("style");
  style.textContent = `
      #fc_frame{
      z-index: 998 !important;
      }
       #fc_frame.fc-open{
        z-index: 1000 !important;       
        
      }

      .fc-widget-normal.fc-open {
        bottom: 20px !important;
        right: calc(50% - 255px + 20px) !important;
        left: auto !important;
        
      }
      
      @media screen and (max-width: 767px) {
        .custom_fc_frame {
          right: 20px !important;
        }
      }
    `;
  document.head.appendChild(style);
  const { superBannersData } = useSelector((state) => state.banners);
  const [showPushModal, setShowPushModal] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(null);

  useEffect(() => {
    dispatch(fetchBanners());
  }, [dispatch]);

  const findEligibleBanner = (banners, isLoggedIn) => {
    if (!Array.isArray(banners)) return null;

    return banners.find(
      (banner) =>
        banner.is_active &&
        banner.master_typeid === 3 &&
        (isLoggedIn
          ? !banner.before_login && banner.after_login
          : banner.before_login && !banner.after_login)
    );
  };

  useEffect(() => {
    const seenBanners = JSON.parse(localStorage.getItem("seenBanners") || "[]");
    const isLoggedIn = token && token.length > 0;
    const isJustSignedUp =
      signupSuccess || sessionStorage.getItem("isNewSignup") === "true";

    const modalBanner = findEligibleBanner(superBannersData, isLoggedIn);

    if (
      modalBanner &&
      !seenBanners.includes(modalBanner.banner_id) &&
      !isJustSignedUp
    ) {
      setSelectedBanner(modalBanner);
      setShowPushModal(true);
    }
  }, [token, superBannersData, signupSuccess]);

  useEffect(() => {
    const cleanup = () => {
      if (!token) {
        sessionStorage.removeItem("isNewSignup");
        setIsNewSignup(false);
      }
    };

    window.addEventListener("beforeunload", cleanup);
    return () => {
      window.removeEventListener("beforeunload", cleanup);
      cleanup();
    };
  }, [token]);

  useEffect(() => {
    if (token) {
      const storedRoute = localStorage.getItem("intendedRoute");
      if (storedRoute) {
        try {
          const { labelName, menuLink, isGame } = JSON.parse(storedRoute);

          // Check if this route should be ignored
          if (shouldIgnoreRoute(labelName, menuLink)) {
            localStorage.removeItem("intendedRoute");
            return; // Exit early, don't navigate
          }

          localStorage.removeItem("intendedRoute");

          // dispatch(setHomePopUp(true));

          if (isGame) {
            const filteredGames = filterByGameType(labelName);
            const gamesList =
              filteredGames[0]?.game?.length > 0 ? filteredGames[0]?.game : [];
            navigate(`/games/${labelName}`, {
              state: {
                gamesList,
                title: labelName,
                game_type: labelName,
              },
            });
          } else if (
            labelName.toLowerCase() === "promotions" ||
            labelName.toLowerCase() === "offers"
          ) {
            navigate("/promotions");
          } else {
            navigate(menuLink);
          }
        } catch (error) {
          console.error("Error handling stored route:", error);
          localStorage.removeItem("intendedRoute");
        }
      }
    }
  }, [token]);

  const handleCloseModal = () => {
    setShowPushModal(false);

    if (selectedBanner) {
      const seenBanners = JSON.parse(
        localStorage.getItem("seenBanners") || "[]"
      );
      if (!seenBanners.includes(selectedBanner.banner_id)) {
        seenBanners.push(selectedBanner.banner_id);
        localStorage.setItem("seenBanners", JSON.stringify(seenBanners));
      }
    }
    setSelectedBanner(null);
  };

  useEffect(() => {
    const pendingGame = localStorage.getItem("pendingGame");

    if (pendingGame && token && location.pathname === "/") {
      try {
        const game = JSON.parse(pendingGame);
        dispatch(setGameDetails(game));
        dispatch(setGamePopup(true));
      } catch (error) {
        console.error("Error handling pending game:", error);
        localStorage.removeItem("pendingGame");
      }
    }
  }, [token, location.pathname]);

  const filterByGameType = useFilterGamesByType();
  useEffect(() => {
    if (token) {
      const storedRoute = localStorage.getItem("intendedRoute");
      if (storedRoute) {
        try {
          const { labelName, menuLink, isGame } = JSON.parse(storedRoute);
          localStorage.removeItem("intendedRoute");

          // dispatch(setHomePopUp(true));

          if (isGame) {
            const filteredGames = filterByGameType(labelName);
            const gamesList =
              filteredGames[0]?.game?.length > 0 ? filteredGames[0]?.game : [];
            navigate(`/games/${labelName}`, {
              state: {
                gamesList,
                title: labelName,
                game_type: labelName,
              },
            });
          } else if (
            labelName.toLowerCase() === "promotions" ||
            labelName.toLowerCase() === "offers"
          ) {
            navigate("/promotions");
          } else {
            navigate(menuLink);
          }
        } catch (error) {
          console.error("Error handling stored route:", error);
          localStorage.removeItem("intendedRoute");
        }
      }
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      const pendingGame = localStorage.getItem("pendingGame");
      const intendedViewAll = localStorage.getItem("intendedViewAll");

      if (intendedViewAll) {
        try {
          const { categoryName, gamesList, type } = JSON.parse(intendedViewAll);

          // Check if this category should be ignored
          if (shouldIgnoreRoute(categoryName)) {
            localStorage.removeItem("intendedViewAll");
            return; // Exit early, don't navigate
          }

          localStorage.removeItem("intendedViewAll");

          // dispatch(setHomePopUp(true));

          if (type === "viewAll") {
            navigate(`/games/${categoryName}`, {
              state: {
                gamesList,
                title: categoryName,
                game_type: categoryName,
              },
            });
          }
        } catch (error) {
          console.error("Error handling viewAll route:", error);
          localStorage.removeItem("intendedViewAll");
        }
      } else if (pendingGame && location.pathname === "/") {
        try {
          const game = JSON.parse(pendingGame);
          dispatch(setGameDetails(game));
          dispatch(setGamePopup(true));
          localStorage.removeItem("pendingGame");
        } catch (error) {
          console.error("Error handling pending game:", error);
          localStorage.removeItem("pendingGame");
        }
      }
    }
  }, [token, location.pathname]);
  const handleCloseBonusModal = () => {
    setShowBonusModal(false);
  };

  const getLoyaltyContent = () => {
    if (
      userLoyalty?.lifeTimeCoins <=
      LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0].levelCutoff
    ) {
      return {
        image: require("../../assets/images/loyalty/dash.webp"),
        level: "DASH",
      };
    } else if (
      userLoyalty?.lifeTimeCoins <=
      LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1].levelCutoff
    ) {
      return {
        image: require("../../assets/images/loyalty/sprint.webp"),
        level: "SPRINT",
      };
    } else if (
      userLoyalty?.lifeTimeCoins <=
      LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2].levelCutoff
    ) {
      return {
        image: require("../../assets/images/loyalty/surge.webp"),
        level: "SURGE",
      };
    } else if (userLoyalty?.level === "level3") {
      return {
        image: require("../../assets/images/loyalty/thrill.webp"),
        level: "THRILL",
      };
    } else if (userLoyalty?.level === "level4") {
      return {
        image: require("../../assets/images/loyalty/boss.webp"),
        level: "BOSS",
      };
    }
    return {
      image: require("../../assets/images/loyalty/dash.webp"),
      level: "DASH",
    };
  };

  return (
    <React.Fragment>
      <div
        className={`SB-Lite ${location.pathname === "/" ? "SB-homePage" : ""} ${
          token?.length === 0 && "SB-nonLoggedIn"
        } ${crashGames ? "SB-crashGames-page" : ""} SB-myAccountPage`}
        ref={topRef}
      >
        <PushNotificationModal
          isOpen={showPushModal}
          onClose={handleCloseModal}
          selectedBanner={selectedBanner}
        />
        <div className="SB-layout-header" id="page-layoutHeader">
          {/* <div className="SB-deposit-header">
            <div className="SB-depositMpesa-mpesa">MPESA Paybill: 4999936</div>
            {token?.length > 0 && (
              <div className="SB-deposit-header-rightSection">
                <div className="SB-btnContainer">
                  <button
                    className="btn SB-btnSecondary SB-btnMedium active SB-btnDepositMyAccount"
                    onClick={() => navigateTo("deposit")}
                  >
                    Deposit
                  </button>
                </div>
              </div>
            )}
          </div> */}
          <Header />
        </div>
        <div className="SB-container">
          <div className="SB-layout-content">
            <div className="SB-mainSection">
              <div className="SB-mainSection-content">
                {element}

                <Footer />
              </div>
            </div>
          </div>
        </div>
        {token?.length > 0 ? (
          <BottomMenu />
        ) : (
          // <div
          //   className="SB-chatBubble"
          //   id="SB-chatBubble"
          //   onClick={handleChatClick}
          // >
          //   <div className="SB-chatBubble-container">
          //     <div className="SB-iconSVG" title="Chat">
          //       <svg xmlns="http://www.w3.org/2000/svg">
          //         <use xlinkHref={`${icons}#${"icon-chat"}`} />
          //       </svg>
          //     </div>
          //     {/* <div className="SB-loader-container d-none">
          //       <div className="SB-loader"></div>
          //     </div> */}
          //   </div>
          // </div>
          ""
        )}
        {signupSuccess && (
          <div
            className="SB-modal SB-registerSuccess-modal SB-modal-medium open"
            id="SB-registerSuccess-modal"
          >
            <div className="SB-modal-dialog">
              <div className="SB-modal-content">
                <div
                  className="SB-modal-close"
                  onClick={() => dispatch(setSignupSuccess(false))}
                >
                  <div className="SB-iconSVG" title="close">
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use xlinkHref={`${icons}#icon-close`}></use>
                    </svg>
                  </div>
                </div>
                <div className="SB-modal-header">
                  <iframe src="https://lottie.host/embed/e9255bf4-e53b-4667-8025-59d2045d704e/vgc5wxHHuj.json"></iframe>
                  <div className="SB-modal-title">Welcome aboard!</div>
                </div>
                <div className="SB-modal-body">
                  <p>
                    Make your first deposit to unlock your welcome bonus and
                    access to free games.
                  </p>
                </div>
                <div className="SB-modal-footer">
                  <div className="SB-btnContainer">
                    <button
                      className="btn SB-btnDeposit SB-btnSecondary active SB-btnLarge"
                      onClick={() => {
                        dispatch(setSignupSuccess(false));
                        sessionStorage.setItem("isNewSignup", "true");
                        setIsNewSignup(true);
                        navigate("/deposit");
                      }}
                    >
                      Deposit Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showBonusModal && (
          <div
            className="SB-modal SB-loyaltyLevel-modal open"
            id="SB-loyaltyLevel-modal"
          >
            <div className="SB-modal-dialog">
              <div className="SB-modal-content">
                <div className="SB-modal-close" onClick={handleCloseBonusModal}>
                  <div className="SB-iconSVG" title="close">
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use xlinkHref={`${icons}#icon-close`}></use>
                    </svg>
                  </div>
                </div>
                <div className="SB-modal-body">
                  <div
                    className="SB-loyaltyLevel-success"
                    id="SB-loyaltyLevel-success"
                  >
                    <img
                      src={getLoyaltyContent().image}
                      alt={getLoyaltyContent().level.toLowerCase()}
                    />
                    <div className="SB-confetti">
                      <div className="SB-confetti-Before"></div>
                    </div>
                    <div className="SB-modal-header">
                      <div className="SB-modal-title">Congratulations</div>
                      <p>
                        {bonusAmount.toFixed(2)} KES bonus added to your cash
                        balance
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default HomeLayout;
